import React from 'react';
import { TQuoteBlockData } from '../types';
import { getHighlightSelectionTipProps } from '../withHighlightSelectionTip';
import { withHighlightAsText } from '../../Highlight/services/withHighlightAsText';
import { parseWithoutNonBreakingSpaces } from '../services/parseWithoutNonBreakingSpaces';
import { HighlightSelectionHint, TQuoteHighlightBlockData } from '../../Highlight/types';

export const renderQuote = ({ text, caption }: TQuoteBlockData, highlightData?: TQuoteHighlightBlockData) => {
  const { text: highlightText, caption: highlightCaption } = highlightData || {};
  return (
    <figure className="article__blockquote">
      <blockquote {...getHighlightSelectionTipProps(HighlightSelectionHint.Text)}>
        {parseWithoutNonBreakingSpaces(withHighlightAsText(text, highlightText))}
      </blockquote>
      <figcaption {...getHighlightSelectionTipProps(HighlightSelectionHint.Caption)}>
        {parseWithoutNonBreakingSpaces(withHighlightAsText(caption, highlightCaption))}
      </figcaption>
    </figure>
  );
};
